import React from 'react';
import StepWithQuestionsAndAnswers from '../stepWithQuestionsAndAnswers/stepWithQuestionsAndAnswers';

const PolicyHolderReviewClaimQuestionsAnswers = (props: {
    questionsWithAnswersGroupedByStep: Array<any> | null;
}): JSX.Element | null => {
    const { questionsWithAnswersGroupedByStep } = props;

    if (!questionsWithAnswersGroupedByStep) {
        return null;
    }
    return (
        <div>
            {questionsWithAnswersGroupedByStep.map(
                stepWithQuestionsAndAnswers => (
                    <StepWithQuestionsAndAnswers
                        key={stepWithQuestionsAndAnswers.code}
                        stepWithQuestionsAndAnswers={
                            stepWithQuestionsAndAnswers
                        }
                    />
                ),
            )}
        </div>
    );
};

export default PolicyHolderReviewClaimQuestionsAnswers;
